import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";

const OpenModal = ({ modalOpen, onClose, title, content, HtmlPath }) => {
  const [renderedHtml, setRenderedHtml] = useState("");
  //const [customFeature, setCustomFeature] = useState("");

  useEffect(() => {    
    if (modalOpen && HtmlPath) {
      fetch(`${HtmlPath}?t=${new Date().getTime()}`) // Prevent cache issues
        .then((response) => {
          if (!response.ok) throw new Error("Failed to load HTML file");
          return response.text();
        })
        .then((html) => setRenderedHtml(html))
        .catch((error) => {
          console.error("Error loading HTML file:", error);
          setRenderedHtml("<p>Error loading content</p>"); // Fallback UI
        });
    } else {
      setRenderedHtml(""); // Clear content if modal closes
    }
  }, [modalOpen, HtmlPath]); // Re-fetch when modal opens or path changes

  return (
    <Dialog id="mypopup" open={modalOpen} onClose={onClose} aria-labelledby="popup-title">
      <h2 id="popup-title" className="flex-center">
        <span style={{ paddingRight: "1em" }}>{title}</span>
        <button
          onClick={onClose}
          aria-label="close"
          className="d-inline-block cursor-pointer line-height-normal"
          style={{ background: "none", border: "none", cursor: "pointer" }}
        >
          <CloseIcon style={{ color: "white" }} />
        </button>
      </h2>
      <div className="popup-body p-3">
        {content}        
        <div dangerouslySetInnerHTML={{ __html: renderedHtml }} />
      </div>
    </Dialog>
  );
};

export default OpenModal;
